module.exports = __webpack_public_path__ + "static/life-insurance-hero-mobile.d93f6dc6.webp";